import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Autocomplete,
  TextField,
  Stack,
  Dialog,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import { getProject } from "../../services/project.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import Delete_Icon from "../../assets/images/Task_File_Delete_Icon.svg";
import Download_Icon from "../../assets/images/Task_File__Donwload_Icon.svg";
import AddIcon from "@mui/icons-material/Add";
import { useAuth } from "../../context/AuthProvider";
import { jwtDecode } from "jwt-decode";
import { REQUEST_STATUS } from "../../common/constant/constant";
import { postRequest, updateRequest } from "../../services/request";
import { getProjectBasedClient } from "../../services/client.service";

const getStatusLabel = (priorityValue) => {
  const statusMap = {
    [REQUEST_STATUS.COMPLETED]: 1,
    [REQUEST_STATUS.ACKNOWLEDAGED]: 2,
    [REQUEST_STATUS.PENDING]: 3,
  };
  return statusMap[priorityValue];
};

const getStatusValue = (label) => {
  const statusMap = {
    Completed: REQUEST_STATUS.COMPLETED,
    Acknowledge: REQUEST_STATUS.ACKNOWLEDAGED,
    Pending: REQUEST_STATUS.PENDING,
  };
  return statusMap[label];
};

const AddRequest = (props) => {
  const { setOpenDrawer, formType, selectedData, GetData, userData } = props;
  console.log(userData, "RSD");
  console.log("selectedData", selectedData);
  const disabled = formType === "view";
  const { accessToken } = useAuth();
  const formRef = useRef(null);
  const [projectData, setProjectData] = useState([]);
  const [clientData, setClientData] = useState([]);
  console.log(clientData, "clientData");
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [shouldCloseOnSubmit, setShouldCloseOnSubmit] = useState(false);

  const [selectedProjectData, setSelectedProjectData] = useState(null);
  console.log(selectedProjectData, shouldCloseOnSubmit);

  // File management state
  const [existingFiles, setExistingFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);

  const [initialValues, setInitialValues] = useState({
    project: "",
    client: "",
    title: "",
    description: "",
    status: null,
  });

  const validationSchema = Yup.object().shape({
    project: Yup.string().required("Project is required"),
    client: Yup.string().required("Client is required"),
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
  });

  const statusOption = [
    ...(userData?.role !== 2
      ? [
          {
            label: "Acknowledge",
            name: "Acknowledge",
            value: REQUEST_STATUS.ACKNOWLEDAGED,
          },
        ]
      : []),
    {
      label: "Completed",
      name: "Completed",
      value: REQUEST_STATUS.COMPLETED,
    },
  ];

  const getUserIdFromToken = () => {
    if (!accessToken) return null;
    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const GetProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });

      if (res.data.data && Array.isArray(res.data.data)) {
        const configData = res.data.data.map((e) => {
          return {
            ...e,
            label: e.name,
          };
        });
        setProjectData(configData);
      } else {
        console.error("Response data is not in expected format:", res.data);
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };
  const GetProjectBasedClientData = async () => {
    try {
      const res = await getProjectBasedClient(selectedProjectData._id);

      if (res.data.data && Array.isArray(res.data.data)) {
        const configData = res.data.data.map((e) => {
          return {
            ...e,
            label: e.name,
          };
        });
        setClientData(configData);
      } else {
        console.error("Response data is not in expected format:", res.data);
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };

  useEffect(() => {
    GetProjectBasedClientData();
  }, [selectedProjectData]);

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      if (selectedData.project_info) {
        setSelectedProjectData(selectedData.project_info);
      }
    }

    GetProjectData();

    if (formType === "edit" || formType === "view") {
      const cleanDescription =
        selectedData.description?.replace(/<[^>]*>/g, "") || "";
      console.log("sssssssssssssss", selectedData.status === "Not Set");

      const statusValue = getStatusValue(selectedData?.status);
      setInitialValues({
        project: selectedData.project || "",
        client: selectedData?.client || "",
        title: selectedData.title || "",
        description: cleanDescription,
        status: statusValue == undefined ? REQUEST_STATUS.PENDING : statusValue,
      });

      if (selectedData.file) {
        const files = Array.isArray(selectedData.file)
          ? selectedData.file
          : [selectedData.file];
        setExistingFiles(files.filter((file) => file && file.location));
      }
    }
  }, [formType, selectedData]);

  const getFileType = (filename) => {
    if (!filename) return "other";
    const extension = filename.split(".").pop().toLowerCase();
    switch (extension) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return "image";
      case "mp4":
      case "webm":
      case "ogg":
        return "video";
      case "pdf":
        return "pdf";
      case "doc":
      case "docx":
        return "word";
      case "xls":
      case "xlsx":
        return "excel";
      default:
        return "other";
    }
  };

  const renderFile = (file) => {
    const fileName = file.fileName || file.name;
    const fileUrl = file.location || URL.createObjectURL(file);
    const fileType = getFileType(fileName);

    if (fileType === "video") {
      return (
        <video
          controls
          style={{ width: "180px", maxHeight: "100px", flex: "1 1 200px" }}
        >
          <source src={fileUrl} type={file.type} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (fileType === "image") {
      return (
        <img
          src={fileUrl}
          alt="Uploaded content"
          style={{
            width: "180px",
            maxHeight: "100px",
            flex: "1 1 200px",
            cursor: "pointer",
          }}
          onClick={() => handleImageClick(fileUrl)}
        />
      );
    }

    return (
      <div style={{ padding: "10px", width: "180px" }}>
        <div style={{ fontWeight: "bold", wordBreak: "break-word" }}>
          {fileName}
        </div>
        <div style={{ fontSize: "12px", color: "#666" }}>
          {fileType.toUpperCase()} file
        </div>
      </div>
    );
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImageDialog(true);
  };

  const fileInputRef = useRef(null);

  const handleAddIconClick = () => {
    fileInputRef.current.click();
  };

  const handleDeleteFile = (file) => {
    if (file?._id) {
      // Existing file - mark for deletion
      setDeletedFiles([...deletedFiles, file?._id]);
      setExistingFiles(existingFiles.filter((f) => f?._id !== file?._id));
    } else {
      // New file - just remove from the list
      setNewFiles(newFiles.filter((f) => f.name !== file.name));
    }
  };

  const handleDownloadFile = (file) => {
    const fileUrl = file.location || URL.createObjectURL(file);
    const fileName = file.fileName || file.name;
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const filesArray = Array.from(files);
      setNewFiles((prev) => [...prev, ...filesArray]);
    }
    // Reset the input value to allow selecting the same file again
    e.target.value = null;
  };

  const onSubmit = async (values, { resetForm }) => {
    try {
      const formData = new FormData();
      const userId = getUserIdFromToken();

      // Convert display labels back to numeric values for backend
      const bodyData = {
        title: values.title,
        description: values.description,
        project: values.project,
        client: values.client,
        status: values.status || REQUEST_STATUS.PENDING,
        createdBy: userId,
      };

      formData.append("bodyData", JSON.stringify(bodyData));

      // Append new files
      newFiles.forEach((file) => {
        formData.append("files", file);
      });

      // If editing, include deleted file IDs
      if (formType === "edit" && deletedFiles.length > 0) {
        formData.append("deletedFiles", JSON.stringify(deletedFiles));
      }
      const apiMethod =
        formType === "edit" || formType === "view"
          ? () => updateRequest(selectedData?._id, formData)
          : () => postRequest(formData);

      const res = await apiMethod();
      ToastSuccess(res.data.message);

      // Reset form and state
      resetForm();
      setNewFiles([]);
      setDeletedFiles([]);
      setExistingFiles([]);
      GetData();
      setOpenDrawer(false);
    } catch (error) {
      ToastError(error?.response?.data?.message || "An error occurred");
      console.error("Submission error:", error);
    }
  };

  const displayFiles = [
    ...existingFiles.filter((file) => !deletedFiles.includes(file?._id)),
    ...newFiles,
  ];

  return (
    <div className={`${"addRenderingPopup"} no-scrollbar`}>
      <Box className="addContainerHeader">
        <Typography className="headerTitle">
          {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "}
          Request
        </Typography>
        <CloseIcon
          className="Close-Icon"
          onClick={() => setOpenDrawer(false)}
        />
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, values, setFieldValue }) => {
          console.log(values, "values");
          return (
            <Form>
              <Box className="addContainerCenter" mb={1}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Project <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={projectData}
                        value={
                          projectData.find(
                            (option) => option?._id === values.project
                          ) || null
                        }
                        disabled={disabled}
                        onChange={(e, v) => {
                          setFieldValue("project", v?._id);
                          setSelectedProjectData(v);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            focused={false}
                            placeholder="Select Project"
                            className="AutoComplete_InputBox"
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.project && errors.project && errors.project}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Client <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={clientData}
                        value={
                          clientData.find(
                            (option) => option?._id === values.client
                          ) || null
                        }
                        disabled={disabled}
                        onChange={(e, v) => {
                          setFieldValue("client", v?._id);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            focused={false}
                            placeholder="Select Client"
                            className="AutoComplete_InputBox"
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.client && errors.client && errors.client}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={1}>
                    <Typography className="inputLabel">
                      Title <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="title"
                      className="InputField"
                      placeholder="Enter Title"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.title && errors.title && errors.title}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={1}>
                    <Typography className="inputLabel">
                      Description <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="description"
                      as="textarea"
                      className="InputField"
                      placeholder="Enter Description"
                      disabled={disabled}
                      style={{ minHeight: "100px" }}
                    />
                    <div className="form-error">
                      {touched.description &&
                        errors.description &&
                        errors.description}
                    </div>
                  </Grid>

                  {formType !== "add" && (
                    <Grid item xs={12} sm={6} mt={1}>
                      <div className="wsh-form-control">
                        <Typography className="inputLabel">Status</Typography>
                        <Autocomplete
                          options={statusOption}
                          value={
                            statusOption.find(
                              (option) => option.value === values.status
                            ) || null
                          }
                          // disabled={disabled}
                          onChange={(e, v) => {
                            setFieldValue("status", v?.value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              focused={false}
                              placeholder="Select Status"
                              className="AutoComplete_InputBox"
                            />
                          )}
                        />
                        <div className="form-error">
                          {touched.status && errors.status && errors.status}
                        </div>
                      </div>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={12} mt={1}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="inputLabel">
                        Attachments
                      </Typography>
                      {!disabled && (
                        <AddIcon
                          onClick={handleAddIconClick}
                          sx={{ cursor: "pointer" }}
                        />
                      )}
                    </Stack>
                    <input
                      type="file"
                      hidden
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      multiple
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 2,
                        mt: 1,
                      }}
                    >
                      {displayFiles.length > 0 ? (
                        displayFiles.map((file, index) => (
                          <Box
                            key={index}
                            sx={{
                              border: "1px solid #E4E4E7",
                              width: "181px",
                              position: "relative",
                              borderRadius: "4px",
                              overflow: "hidden",
                            }}
                          >
                            {renderFile(file)}
                            <img
                              src={Download_Icon}
                              alt="Download"
                              style={{
                                position: "absolute",
                                top: 10,
                                right: !disabled ? 35 : 10,
                                cursor: "pointer",
                                background: "white",
                                borderRadius: "5px",
                                padding: "2px",
                              }}
                              onClick={() => handleDownloadFile(file)}
                            />
                            {!disabled && (
                              <img
                                src={Delete_Icon}
                                alt="Delete_Icon"
                                style={{
                                  position: "absolute",
                                  top: 10,
                                  right: 10,
                                  cursor: "pointer",
                                  background: "white",
                                  borderRadius: "5px",
                                  padding: "2px",
                                }}
                                onClick={() => handleDeleteFile(file)}
                              />
                            )}
                          </Box>
                        ))
                      ) : (
                        <Typography>No Files Attached</Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Divider sx={{ opacity: 1 }} />
              <Grid className="addboxFooter">
                <Button
                  className="cancelButton"
                  onClick={() => setOpenDrawer(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="saveButton"
                  onClick={() => {
                    setShouldCloseOnSubmit(false);
                  }}
                >
                  Save
                </Button>
                {/* {!disabled && (
                <>
                  <Button
                    type="submit"
                    className="saveButton"
                    onClick={() => {
                      setShouldCloseOnSubmit(false);
                    }}
                  >
                    Save
                  </Button>
                </>
              )} */}
              </Grid>
            </Form>
          );
        }}
      </Formik>
      <Dialog
        open={openImageDialog}
        onClose={() => setOpenImageDialog(false)}
        maxWidth="lg"
        fullWidth
      >
        <img
          src={selectedImage}
          alt="Full Screen"
          style={{ width: "100%", height: "auto" }}
        />
      </Dialog>
    </div>
  );
};

export default AddRequest;